var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-extend-menu-section-contents" },
    _vm._l(_vm.recordList, function (record) {
      return _c("RoomChatForm", {
        key: record.recordId,
        attrs: {
          type: "record",
          "data-record-id": record.recordId,
          section: _vm.section,
          item: _vm.itemObj(record),
        },
        on: {
          onClickDownload: function ($event) {
            return _vm.handleClickDownloadRecord(record)
          },
          onClickDelete: _vm.onClickDelete,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }